import category from './Category'

export const NAMESPACE = 'admin'

const Index = {
  namespaced: true,
  modules: {
    category
  }
}

export default Index



// WEBPACK FOOTER //
// ./src/app/admin/store/Index.js